type TPromiseResolve = (value: void | PromiseLike<void>) => void;

/* Bootstrap size XL >= 1200 */
export const XLargeScreenWidthStart = 1200;

/* Bootstrap size L >= 992 */
export const LargeScreenWidthStart = 992;

/* Bootstrap size M >= 768 */
export const MediumScreenWidthStart = 768;

/* Bootstrap size XS < 576 */
/* Bootstrap size S >= 576 */
export const SmallScreenWidthStart = 576;

// Custom size limit for really small screens
export const TinyScreenWidthStart = 400;
export const MicroScreenWidthStart = 200;

function restoreFocusEventHander(ev: Event): void {
    const target = ev.target;

    if (document.activeElement === target) {
        return;
    }
    
    if (target instanceof HTMLElement) {
        target.focus();
    }
}

export async function onElementEventAsync<K extends keyof HTMLElementEventMap, E extends HTMLElement>(event: K, element: E, listener: (ev: HTMLElementEventMap[K]) => void): Promise<void> {
    let resolveFunc: TPromiseResolve = () => {};

    const eventProxy = (ev: HTMLElementEventMap[K]): void => {
        listener(ev);
        resolveFunc();
    };

    const resolvePromise = new Promise<void>((resolve) => {
        resolveFunc = resolve;
        element.addEventListener(event, eventProxy);
    });

    await resolvePromise;
    element.removeEventListener(event, eventProxy);
}

export async function restoreFocusOnBlurEventAsync<E extends HTMLElement>(element: E): Promise<void> {
    // If the element is not the currenct focused element, then blur will not be called
    if (document.activeElement !== element) {
        return;
    }

    await onElementEventAsync("blur", element, restoreFocusEventHander);
}

export function browserViewHeight(): number {
    return Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
}

export function browserViewWidth(): number {
    return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
}

export function isSmallScreen(): boolean {
    return browserViewWidth() < MediumScreenWidthStart;
}

export function isTinyScreen(): boolean {
    return browserViewWidth() < SmallScreenWidthStart;
}